:host {
  display: block;

  --_omk-validation-error-colour: var(--omk-validation-error-colour, var(--omk-colour-text-danger-resting));
  --_omk-validation-error-font-family: var(--omk-validation-error-font-family, var(--omk-font-body-xsmall-font-family));
  --_omk-validation-error-font-size: var(--omk-validation-error-font-size, var(--omk-font-body-xsmall-font-size));
  --_omk-validation-error-font-style: var(--omk-validation-error-font-style, var(--omk-font-body-xsmall-font-style));
  --_omk-validation-error-font-weight: var(--omk-validation-error-font-weight, var(--omk-font-body-xsmall-font-weight));
  --_omk-validation-error-line-height: var(--omk-validation-error-line-height, var(--omk-font-body-xsmall-line-height));
  --_omk-validation-error-letter-spacing: var(--omk-validation-error-letter-spacing, var(--omk-font-body-xsmall-letter-spacing));

  color: var(--_omk-validation-error-colour);
  font-family: var(--_omk-validation-error-font-family);
  font-size: var(--_omk-validation-error-font-size);
  font-style: var(--_omk-validation-error-font-style);
  font-weight: var(--_omk-validation-error-font-weight);
  line-height: var(--_omk-validation-error-line-height);
  letter-spacing: var(--_omk-validation-error-letter-spacing);

  &.hide {
    display: none;
  }
}
